'use client';

import { Text } from '@backyard-ui/core';

import { algolia } from '@/infra/tracking/algolia';
import { ANCHORS } from '@/presenters/components/catalog/constants';

export default function CharacteristicsButton() {
  return (
    <Text
      color="primary-700"
      weight="bold"
      asChild
      decoration="underline"
      size="md"
    >
      <a
        className="self-start"
        href={`#${ANCHORS.characteristics}`}
        onClick={() => algolia.sendPdpClickEvent()}
      >
        Ver descrição técnica
      </a>
    </Text>
  );
}
